import React from 'react'

import Header from '../Menhome/Header'
import Bredcom from '../MenTeam/Bredcom'
import Footer from '../Menhome/Footer'
import CancellationRefundPolicy from '../Menpages/refund-policy/main'


function Refundpolicy() {
  return (
    <>
    <Header/>
    <Bredcom title={"Policies"} head={"Cancellation and Refund Policy"} sbtitle={"Refund Policy"}/>
    <CancellationRefundPolicy/>
    <Footer/>
    </>
  )
}

export default Refundpolicy;